import _defineProperty from "@babel/runtime/helpers/defineProperty";
export default class ErrorReporter {
  constructor() {
    _defineProperty(this, "handlerStorage", null);
  }

  captureMessage(msg, tags) {
    if (this.handlerStorage) {
      this.handlerStorage.captureMessage(msg, tags);
    }
  }

  captureException(err, tags) {
    if (this.handlerStorage) {
      this.handlerStorage.captureException(err, tags);
    }
  }

  set handler(handler) {
    this.handlerStorage = handler;
  }

}